function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "#EA4968",
  stroke: "#EA4968",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#F2F6FA",
  strokeWidth: 2,
  d: "M5 10h10"
});

const SvgMinusHover = props => React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none"
}, props), _ref, _ref2);

export default SvgMinusHover;